export const brandCode = (import.meta.env.VITE_BRAND_CODE ?? '').trim().toLowerCase();
export const brandFriendlyName = import.meta.env.VITE_CLIENT_FRIENDLY_NAME;
